import { render, staticRenderFns } from "./SettlementsCorrectionsDialog.vue?vue&type=template&id=da2d5492&"
import script from "./SettlementsCorrectionsDialog.vue?vue&type=script&lang=js&"
export * from "./SettlementsCorrectionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports